<template>
<div class="navs">
    <el-menu mode="vertical" default-active="1" background-color="#496cfc" text-color="#c5d3f8" active-text-color="#fff">
        <el-submenu index="1">
            <template slot="title">旅行社管理</template>
            <el-menu-item-group>
                <el-menu-item index="1-1">
                    <router-link to="/area/travelList"> 旅行社列表 </router-link>
                </el-menu-item>
            </el-menu-item-group>
        </el-submenu>
        <el-submenu index="2">
            <template slot="title">保单管理</template>
            <el-menu-item-group>
                <el-menu-item index="2-1">
                    <router-link to="/area/policyList"> 保单列表 </router-link>
                </el-menu-item>
                <el-menu-item index="2-2">
                    <router-link to="/area/orderCount"> 保单统计 </router-link>
                </el-menu-item>
            </el-menu-item-group>
        </el-submenu>
        <el-submenu index="3">
            <template slot="title">提现管理</template>
            <el-menu-item-group>
                <el-menu-item index="3-1">
                    <router-link to="/area/cashCount"> 提现统计 </router-link>
                </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
                <el-menu-item index="3-2">
                    <router-link to="/area/cashList"> 提现列表 </router-link>
                </el-menu-item>
            </el-menu-item-group>
        </el-submenu>
    </el-menu>
</div>
</template>

<script>
export default {};
</script>

<style scoped>
.navs {
    height: 100%;
    background-color: #496cfc;
    overflow: hidden;
    overflow-y: auto;
}

.el-menu-item a {
    color: rgb(197 211 248);
    display: block;
}

.el-menu-item.is-active a {
    color: #fff;
}

.logo {
    background-color: #496cfc;
    height: 60px;
    text-align: center;
}

.logo img {
    height: 45px;
    margin-top: 7.5px;
}
</style>
